export class FileToUpload {
    PatientId: string = "";
    fileName: string = "";
    fileSize: number = 0;
    fileType: string = "";
    lastModifiedTime: number = 0;
    lastModifiedDate: Date = null;
    fileAsBase64: string = "";
    Status: string = "";
    FolderType: string = "";
    FilePath: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/Documents/FileToUpload.ts